<header id="navbar" class="navbar navbar-expand-lg fixed-top" role="banner">
  <div class="container">
    @if (complex()) {
      <div class="navbar-translate">
        <button id="navbar-toggler" type="button" class="navbar-toggler" aria-label="Toggle sidebar"
                (click)="openSidebar()">
          <fa-icon [icon]="faBars"></fa-icon>
        </button>
        <a type="button" href="/" title="Strona główna" class="text-decoration-none navbar-brand">
          {{ company.NAME }}
        </a>
      </div>
    } @else {
      <a type="button" href="/" title="Strona główna" class="text-decoration-none navbar-brand">
        {{ company.NAME }}
      </a>
    }
    @if (complex()) {
      <div class="navbar-collapse">
        <div class="row navbar-nav ml-auto">
          @if (withBlog()) {
            <div class="col-md-15 nav-item px-0">
              <a type="button" title="Blog" class="nav-link h-100 text-center align-content-center"
                 href="/{{routes.BLOG}}">
                <div class="row align-items-center h-100">
                  <div class="col-6 col-lg-5 text-end">
                    <i>
                      <fa-icon [icon]="faBook"></fa-icon>
                    </i>
                  </div>
                  <div class="col-6 col-lg-7 ps-0 text-start">
                    <span>Blog</span>
                    <br/>
                    <span>Czytaj</span>
                  </div>
                </div>
              </a>
            </div>
          }
          <div class="col-md-3 nav-item px-0">
            <button class="nav-link h-100" rel="external" title="Rezerwacja" (click)="openBooksyDialog()">
              <div class="row align-items-center h-100">
                <div class="col-6 col-lg-4 text-end">
                  <i>
                    <img ngSrc="assets/booksy.svg" alt="Logo Booksy" height="21" width="28" loading="eager">
                  </i>
                </div>
                <div class="col-6 col-lg-8 ps-0">
                  <span>Zarezerwuj</span>
                  <img ngSrc="assets/booksy-attribution.jpeg" alt="Powered by Booksy" height="10" width="102"
                       loading="eager">
                </div>
              </div>
            </button>
          </div>
          <div class="col-md-3 nav-item px-0">
            <a class="nav-link h-100" title="Telefon" href="tel:{{contact.PHONE_NUMBER}}">
              <div class="row align-items-center h-100">
                <div class="col-6 col-lg-4 text-end">
                  <i>
                    <fa-icon [icon]="faPhone"></fa-icon>
                  </i>
                </div>
                <div class="col-6 col-lg-8 ps-0">
                  <span>{{ contact.PHONE_NUMBER_TEXT }}<br/>Umów wizytę</span>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-3 nav-item px-0">
            <a class="nav-link h-100" rel="noopener external" title="Adres" href="{{address.GOOGLE_MAPS_URL}}"
               target="_blank">
              <div class="row align-items-center h-100">
                <div class="col-md-3 text-end">
                  <i>
                    <fa-icon [icon]="faMapLocationDot"></fa-icon>
                  </i>
                </div>
                <div class="col-md-9">
                  <div class="col">
                    <span>{{ address.ADDRESS_SHORT_TEXT }}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-15 nav-item px-0">
            <div class="row align-items-center h-100">
              <div class="col-md-4">
                <a class="nav-link" rel="noopener external" title="Instagram" href="{{social.INSTAGRAM_URL}}"
                   target="_blank">
                  <i>
                    <fa-icon [icon]="faInstagram"></fa-icon>
                  </i>
                </a>
              </div>
              <div class="col-md-4">
                <a class="nav-link" rel="noopener external" title="Facebook" href="{{social.FACEBOOK_URL}}"
                   target="_blank">
                  <i>
                    <fa-icon [icon]="faFacebookSquare"></fa-icon>
                  </i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</header>
